import AjaxService from '@services/AjaxService';
import BaseRepository from '@repositories/desktop/BaseRepository';

export default class DashboardRepository extends BaseRepository {
  protected baseUrl = '';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService);
  }

  public getDamageRecordApprovedOverviewUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordApprovedOverview');
  }

  public getDamageRecordEditStatusUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordEditStatus');
  }

  public getDamageRecordInactiveFirmsUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordInactiveFirms');
  }

  public getDamageRecordInactivityUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordInactivity');
  }

  public getDamageRecordNewFilesUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordNewFiles');
  }

  public getDamageRecordNoteInquiryUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordNoteInquiry');
  }

  public getDamageRecordNoteReminderUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordNoteReminder');
  }

  public getDamageRecordNoteUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordNote');
  }

  public getDamageRecordOverdueInquiryUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordOverdueInquiry');
  }

  public getDamageRecordOverdueReminderUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordOverdueReminder');
  }

  public getDamageRecordStatusUrl(): string {
    return this.getItemsUrl('Csp_Dashboard_Widget_DamageRecordStatus');
  }

  public getDashboardPermissions(): Promise<string> {
    return this.ajaxService.getJson('/api/desktop/dashboard');
  }

  public getDashboardPreferencesUrl(): Promise<string> {
    return this.ajaxService.getJson('/de/Schaden-Manager/index/dashboardpreferences');
  }

  private getDamageRecordItemDetailUrl(): string {
    return '/de/Schaden-Manager/Akte/detail/vehicleDamageRecordId/replace';
  }

  private getFirmItemDetailUrl(): string {
    return '/de/Schaden-Manager/Firma/Anzeigen/firmId/replace';
  }

  private getItemsUrl(widgetClass: string): string {
    return `/de/Schaden-Manager/index/index/format/json/widget/${widgetClass}`;
  }
}
